import { isH5ZeroOneSwitchOn } from '@/util/h5Permission';
import { checkPermission } from '@/util/hooks/checkPermissions';

/**
 * WIMP 客户个性化：搜列价格排序 + 价格区间 + 品牌筛选 总开关。
 * 约定 1=开、0=关；缺省 0，需在 WIMP 合同级显式配 1。
 */
export const SEARCH_PRICE_FEATURE_KEY = 'S_searchPriceFeature';

/** 价格排序、价格区间、品牌筛选共用同一开关（1 开 / 0 关） */
export function isSearchPriceFeatureEnabled(
  permissions: Record<string, unknown> | undefined,
): boolean {
  return isH5ZeroOneSwitchOn(permissions, SEARCH_PRICE_FEATURE_KEY, false);
}

/** 开关为 0 时剔除 sort / 价格区间 / brandRole，避免 URL 残留触发后端筛选 */
export function sanitizeSearchParamsByPermission(
  params: Record<string, any> | undefined,
  permissions: Record<string, unknown> | undefined,
): Record<string, any> {
  if (!params) {
    return {};
  }
  if (isSearchPriceFeatureEnabled(permissions)) {
    return { ...params };
  }

  const next = { ...params };
  if (next.sort != null && Number(next.sort) !== 0) {
    next.sort = 0;
  }
  next.priceMinFilter = null;
  next.priceMaxFilter = null;
  next.brandRole = [];
  return next;
}

export function sanitizeSearchParamsWithRuntimePermissions(
  params: Record<string, any> | undefined,
): Record<string, any> {
  const permissions =
    typeof checkPermission === 'function'
      ? { [SEARCH_PRICE_FEATURE_KEY]: checkPermission(SEARCH_PRICE_FEATURE_KEY) }
      : undefined;
  return sanitizeSearchParamsByPermission(params, permissions);
}
